import type {ReactElement} from 'react';
import React from 'react';
import {Option} from '@Components/contextual-menu/components/option';
import {InformationBox, InformationBoxType} from '@Components/contextual-menu/components/information-box';

interface ContextualMenuInformationBoxProps {
  id: string;
  containerClassName?: string;
  className?: string;
  type?: InformationBoxType;
  children: ReactElement<any>;
}

export function ContextualMenuInformationBox({
  className = '',
  containerClassName = '',
  type = InformationBoxType.NEUTRAL3,
  ...props
}: ContextualMenuInformationBoxProps): ReactElement<any> | null {
  return <Option key={props.id} className={className} containerClassName={containerClassName} optionControl={<InformationBox type={type}>{props.children}</InformationBox>} />;
}
